import {SEARCH_FORM_DISPLAY} from '../actionType';

export default function (state = {}, action) {
    switch (action.type) {
        case SEARCH_FORM_DISPLAY:
            return {
                ...state,
                displayFlag: action.displayFlag,
            };
        default:
            return state;
    }
}